module.exports = __webpack_public_path__ + "static/how-it-works-step-line-7b9dd2b5e627b16c64b88b97cba149cd.png";